import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { setAppIsLoadingAction } from 'store/app';
import { throttle } from 'utils/throttle';

import { checkSWAlone } from '../serviceWorkerRegister';

const throttledUpdate = throttle((reg?: ServiceWorkerRegistration) => reg?.update().catch(), 30000);

export function useAppUpdate() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    (async () => {
      const isSWAlone = await checkSWAlone();

      const registration = await navigator.serviceWorker.getRegistration();

      if (isSWAlone && registration?.waiting) {
        dispatch(setAppIsLoadingAction(true));

        return registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      if (!registration?.waiting) throttledUpdate(registration);
    })();
  }, [location, dispatch]);
}
